<template>
    <div class="page">
        <div class="section">
			<div class="item">
				<div class="label">
					资料名称:
				</div>
				<el-input type="text" size="mini" placeholder="请输入资料名称" v-model="addCaseMaterial.name"/>
			</div>
		</div>
		<div class="section">
			<div class="materiallist">
				<div class="material" v-for="(item,index) in addCaseMaterialList" :key="index">
					<img src="../../assets/images/icon11.png" alt="" v-if="item.fileType=='mp3'||item.fileType=='aac'||item.fileType=='wav'||item.fileType=='wma'||item.fileType=='flac'||item.fileType=='ape'" :fit="cover" @click="download(item.path,item.fileType)">
					<img src="../../assets/images/icon12.png" alt="" v-else-if="item.fileType=='rmvb'||item.fileType=='rm'||item.fileType=='ts'||item.fileType=='tp'||item.fileType=='avi'||item.fileType=='3gp'||item.fileType=='mp4'||item.materialType=='mkv'" :fit="cover" @click="download(item.path,item.fileType)">
					<img src="../../assets/images/icon13.png" alt="" v-else-if="item.fileType=='xls'||item.fileType=='xlsx'||item.fileType=='doc'||item.fileType=='docx'||item.fileType=='ppt'||item.fileType=='pptx'||item.fileType=='pdf'||item.materialType=='zip'||item.fileType=='rar'" :fit="cover" @click="download(item.path,item.fileType)">
					<img
					:src="item.path"
					v-else
					@click="previewImg(item.path)"
					:fit="cover"/>
					<img src="../../assets/images/icon08.png" class="close" @click="clearMaterial(index)" alt="">
					<div class="filename">{{item.fileName}}</div>
				</div>
                 <el-upload
                    :action="uploadUrl"
                    multiple
                    :show-file-list="false"
                    :http-request="uploadCPath"
                    >
                    <img src="../../assets/images/icon15.png" class="addimg" alt="" >
                </el-upload>

			</div>
		</div>
		<el-button class="btn" type="primary" @click="addMaterial" :loading="finishNum!=allNum?true:false">
			确认新增
		</el-button>
		<div class="tip">{{tip}}</div>
    </div>
</template>

<script>
import api from '../../api/main'

export default {
    
    name: 'index',
    data () {
        return {
            uploadUrl:'',
            addCaseMaterial:{
                name:'',
            },
            addCaseMaterialList:[],
            materialList:[],
            editData:{},
            allNum:0,
            finishNum:0,
			tip:'',
        }
    },
    components:{

    },
    created(){
        
    },
    mounted(){

    },
    
    methods:{
        async clearMaterial(index){
            this.addCaseMaterialList.splice(index,1);
        },
        async uploadCPath(file){
			this.tip = ''
            if(!this.addCaseMaterial.name){
                this.$message({
                    type: 'warning',
					offset:45,
                    message: '请先填写资料名称!'
                });
                return;
            }

            this.allNum = this.allNum+1;
            let name = this.addCaseMaterial.name;
            let fileTypeList = file.file.name.split('.');
            let fileType = fileTypeList[fileTypeList.length-1];
            fileType = fileType.replace(/\s*/g,"");
            let res = await api.uploadOther(file.file);
            console.log(res);

            let path = res;
            this.addCaseMaterialList.push({
                fileType:fileType,
                fileName:file.file.name,
                name:name,
                path:path,
            });
            this.finishNum = this.finishNum+1;
            this.$forceUpdate();

        },
        async addMaterial(){
            console.log(this.addCaseMaterialList);
            let res = await api.MAddDoubtTaskItemDoubTaskMaterial({
                id:this.$route.query.id,
                doubTaskMaterialItems:this.addCaseMaterialList
            });
            if(res.data.code){
                this.$message({
                    type: 'success',
					offset:45,
                    message: '新增成功!'
                });
				this.tip = '资料新增成功，可以返回页面或继续新增。'
                this.addCaseMaterialList = [];
                this.addCaseMaterial.name = '';
            }
            
        },
    },
   
    computed: {
        
    }
}
</script>
 
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss' scoped>
	.page{
		display: flex;
		flex-direction: column;
		align-items: center;
	}
    .section{
		font-size: 14px;
		display: flex;
		flex-wrap: wrap;

		.item{
			display: flex;
			align-items: center;
            padding: 0 15px;
			height: 44px;
			margin: 0 auto;
			border-bottom: 1px solid #f2f2f2;
			.label{
				width: 100px;
				padding-right: 15px;
			}
			input{
				font-size: 14px;
			}
		}
		
		.materiallist{
			display: flex;
			flex-wrap: wrap;
			margin: 0 auto;
			margin-top: 6px;
			width: 360px;
			.addimg{
				width: 109px;
				height: 109px;
				margin:5px;
				margin-top:14px;
			}
			.material{
				border: 1px dashed #7c7c7c;
				width: 100px;
				height: 118px;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				text-overflow:ellipsis;
				white-space: nowrap;
				border-radius: 4px;
				margin:5px;
				position: relative;
				img{
					width: 93px;
					height: 93px;
				}
				.close{
					width: 25px;
					height: 25px;
					position: absolute;
					right: -8px;
					top: -8px;
				}
				.filename{
					width: 100px;
					font-size: 12px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					text-align: center;
					margin-top: 4px;
				}
			}
		}
		
	}
	.btn{
		width: 345px;
		// height: 40px;
		// background-color: #28B3EC;
		// border-radius: 6px;
		// display: flex;
		// align-items: center;
		// justify-content: center;
		// line-height: 40px;
		// color: #FFFFFF;
		margin: 0 auto;
		// font-size: 16px;
		// margin-top: 20px;
		// letter-spacing: 4px;
	}
	.tip{
		font-size: 14px;
		color:#409EFF;
		margin-top: 10px;
	}
</style>

